"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Film = function Film(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    "clip-path": "url(#clip0_3686_2133)"
  }, _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.4",
    d: "M18.757 0V0.520833H17.7153V0H7.29866V0.520833H6.25699V0H5.72913V25H6.24996V24.4792H7.29163V25H17.7083V24.4792H18.75V25H19.2708V0H18.757ZM6.24996 3.64583H7.29163V4.6875H6.24996V3.64583ZM6.24996 7.8125H7.29163V8.85417H6.24996V7.8125ZM6.24996 9.89583H7.29163V10.9375H6.24996V9.89583ZM6.24996 15.1042V14.0625H7.29163V15.1042H6.24996ZM7.29163 16.1458V17.1875H6.24996V16.1458H7.29163ZM6.24293 13.0208V11.9792H7.28459V13.0208H6.24293ZM7.29163 23.4375H6.24996V22.3958H7.29163V23.4375ZM7.29866 21.3542H6.25699V20.3125H7.29866V21.3542ZM7.29866 19.2708H6.25699V18.2292H7.29866V19.2708ZM7.29866 6.77083H6.25699V5.72917H7.29866V6.77083ZM7.29866 2.60417H6.25699V1.5625H7.29866V2.60417ZM17.7083 1.5625H18.75V2.60417H17.7083V1.5625ZM17.7083 11.9792H18.75V13.0208H17.7083V11.9792ZM17.7083 14.0625H18.75V15.1042H17.7083V14.0625ZM18.7429 23.4375H17.7013V22.3958H18.7429V23.4375ZM18.75 21.3542H17.7083V20.3125H18.75V21.3542ZM18.75 19.2708H17.7083V18.2292H18.75V19.2708ZM18.757 17.1875H17.7153V16.1458H18.757V17.1875ZM18.757 10.9375H17.7153V9.89583H18.757V10.9375ZM18.757 8.85417H17.7153V7.8125H18.757V8.85417ZM18.757 6.77083H17.7153V5.72917H18.757V6.77083ZM18.757 4.86111H17.7153V3.81944H18.757V4.86111Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M17.1875 18.75C17.1875 18.4623 16.9543 18.2292 16.6667 18.2292H8.33333C8.04569 18.2292 7.8125 18.4623 7.8125 18.75L7.85547 25H17.1875V18.75Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M7.8125 6.25C7.8125 6.53764 8.04569 6.77083 8.33333 6.77083H16.6667C16.9543 6.77083 17.1875 6.53764 17.1875 6.25V0H7.8125V6.25Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M16.6666 9.375H8.33325V15.625H16.6666V9.375Z",
    fill: props.foregroundColor,
    stroke: props.foregroundColor,
    "stroke-width": "0.5",
    "stroke-linejoin": "round"
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0_3686_2133"
  }, _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: props.foregroundColor
  }))));
};

Film.defaultProps = {
  altText: "Film",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Film.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Film;
exports.default = _default;